const selectedTeamIdsReducer = (data = {}, action) => {
    switch(action.type){
        case 'SELECTED_TEAM_IDS':
            return { ...action.data };
        default:
            return data;
    }
}

export default selectedTeamIdsReducer;
